export default __webpack_public_path__ + "8399f5c49f0c1782a6e3c9a74e3d831a.jpg";